export function calculateInvoiceAmountWithDirectionSplit(params, invoiceTotalAmount, DIRECTION_NAME) {
    const passengers = params.passengers || [];

    const hasOpposite =
        passengers.length > 1 &&
        passengers.some(p => p.haveOppositeDirection === true);

    if (hasOpposite) {
        const passengersOpposite = passengers.filter(p => p.haveOppositeDirection === true);
        const passengersSame = passengers.filter(p => !p.haveOppositeDirection);

        const invertedDirectionType =
            params.directionType === DIRECTION_NAME[0] ? DIRECTION_NAME[1] : DIRECTION_NAME[0];

        const calculatedSame = invoiceTotalAmount({
            ...params,
            passengers: passengersSame
        });

        const calculatedOpposite = invoiceTotalAmount({
            ...params,
            passengers: passengersOpposite,
            directionType: invertedDirectionType
        });

        return {
            sameDirection: calculatedSame,
            oppositeDirection: calculatedOpposite
        };
    }

    const calculated = invoiceTotalAmount(params);
    return { all: calculated };
}
